<template>
  <div class="component">
    <div class="component-title">里程费</div>
    <div style="font-size: 12px;line-height: 20px;color: #C9C2BB;margin-bottom: 4px;">根据地图厂商规划线路计算基本里程，按照下方的定价标准计算订单里程价格</div>
    <div style="border: 1px solid #C9C2BB;border-radius: 4px;overflow: hidden;">
      <div class="flex-sb" style="background-color: #F8F8F8;padding: 0 16px;font-size: 16px;">
        <div style="line-height: 32px;">生效时间段：</div>
        <div style="line-height: 32px;">00：00 - 24：00</div>
      </div>
      <div 
        class="flex-sb mileage-item" 
        style="margin: 0 16px;
        font-size: 12px;"
        v-for="item in mileagesList" :key="item.id"
      >
        <div style="line-height: 44px;">{{ item.name }}</div>
        <div style="line-height: 44px;">{{ $zeroPadding(item.chargeUnit) }}{{item.id === 'price'?'元/公里':'元'}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:["carAttributeFeeConfig"],
  data(){
    return {
      mileagesList:[],
      listCurrent:0,
      childrenCurrent:0
    }
  },
  watch:{
    "carAttributeFeeConfig.mileages":{
      handler(mileages){
        console.log('mileages: ', mileages);
        if(!mileages || !mileages.length) return [];
  
  // 保留起步价
  let newList = mileages.slice(0, 1);
  
  if(mileages.length > 1) {
    const remainingCharges = mileages.slice(1).map(item => item.chargeUnit);
    const minCharge = Math.min(...remainingCharges);
    const maxCharge = Math.max(...remainingCharges);
    
    newList.push({
      name: "分阶段计价（超过起步价）",
      chargeUnit: minCharge===maxCharge?minCharge:`${minCharge}~${maxCharge}`,
      id: 'price'
    });
  }
  
  this.mileagesList = newList;

      },
      
      immediate: true,
      deep:true
    }
  },
}
</script>

<style scoped lang="scss">
  .component-title {
    margin-bottom: 4px;
  }
  .mileage-item + .mileage-item {
    border-top: 1px solid #C9C2BB;
  }
</style>